var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ED1C24",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 22.583a7.583 7.583 0 1 1 0-15.166 7.583 7.583 0 0 1 0 15.166zM13.917 25.833v-.086c0-.596.487-1.084 1.083-1.084s1.083.488 1.083 1.084c0 .596-.487 1.126-1.083 1.126s-1.083-.444-1.083-1.04zm8.049-2.329-.141-.14a1.079 1.079 0 0 1 0-1.528 1.079 1.079 0 0 1 1.527 0l.141.14a1.079 1.079 0 0 1-.758 1.842 1.11 1.11 0 0 1-.77-.314zm-15.47 0a1.079 1.079 0 0 1 0-1.527l.14-.141a1.079 1.079 0 0 1 1.528 0 1.079 1.079 0 0 1 0 1.527l-.14.141a1.084 1.084 0 0 1-1.528 0zm19.25-7.42A1.087 1.087 0 0 1 24.664 15c0-.596.488-1.083 1.084-1.083.596 0 1.126.487 1.126 1.083s-.444 1.083-1.04 1.083h-.086zm-21.58 0A1.087 1.087 0 0 1 3.084 15c0-.596.488-1.083 1.084-1.083.596 0 1.126.487 1.126 1.083s-.444 1.083-1.04 1.083h-.086zm17.659-7.909a1.079 1.079 0 0 1 0-1.528l.14-.14a1.079 1.079 0 0 1 1.528 0 1.079 1.079 0 0 1 0 1.527l-.14.141a1.066 1.066 0 0 1-.759.314 1.11 1.11 0 0 1-.769-.314zm-15.188 0-.141-.152a1.079 1.079 0 0 1 0-1.527 1.079 1.079 0 0 1 1.527 0l.141.14a1.079 1.079 0 0 1 0 1.528 1.051 1.051 0 0 1-.758.325 1.11 1.11 0 0 1-.77-.314zm7.28-3.922v-.086c0-.596.487-1.084 1.083-1.084s1.083.488 1.083 1.084c0 .596-.487 1.126-1.083 1.126s-1.083-.444-1.083-1.04z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon01);
export default __webpack_public_path__ + "static/media/icon-01.8fb5b8aabae2d468232daf0a8a6274ad.svg";
export { ForwardRef as ReactComponent };